// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SubscriptionLifecycleDiagram: MarkdocTagRegistration = {
  tag: 'subscription-lifecycle-diagram',
  component: 'SubscriptionLifecycleDiagram',
};
